__turbopack_context__.v({
  "card": "style-module-scss-module__LIOcCq__card",
  "icon": "style-module-scss-module__LIOcCq__icon",
  "text": "style-module-scss-module__LIOcCq__text",
  "title": "style-module-scss-module__LIOcCq__title",
});
